/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base-Serializer for all user types. Deprecated note: Do not use this serializer
 * directly but, the user type specific serializer, e.g. OrgUserSerializer,
 * GuestUserSerializer.
 * @export
 * @interface APIAllInOneUser
 */
export interface APIAllInOneUser {
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly self: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIAllInOneUser
     */
    readonly isGuestUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAllInOneUser
     */
    readonly isOrgAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAllInOneUser
     */
    readonly isSuperuser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAllInOneUser
     */
    readonly isStaff: boolean;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof APIAllInOneUser
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly roles: string;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly organization: string;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIAllInOneUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIAllInOneUser
     */
    readonly preferences: { [key: string]: any; };
    /**
     * 
     *             <ul style="list-style=none;">
     *                 <li>Required for organization users, as the email is used as the username.</li>
     *                 <li>Guest users do *not* require an email address.</li>
     *             </ul>
     *             
     * @type {string}
     * @memberof APIAllInOneUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly lastName: string;
    /**
     * This is the username used for a guest user.
     * @type {string}
     * @memberof APIAllInOneUser
     */
    readonly guestId: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIAllInOneUser
     */
    readonly timeToLive: number;
    /**
     * 
     * @type {string}
     * @memberof APIAllInOneUser
     */
    repFor?: string;
}

/**
 * Check if a given object implements the APIAllInOneUser interface.
 */
export function instanceOfAPIAllInOneUser(value: object): value is APIAllInOneUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('isGuestUser' in value) || value['isGuestUser'] === undefined) return false;
    if (!('isOrgAdmin' in value) || value['isOrgAdmin'] === undefined) return false;
    if (!('isSuperuser' in value) || value['isSuperuser'] === undefined) return false;
    if (!('isStaff' in value) || value['isStaff'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('preferences' in value) || value['preferences'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('guestId' in value) || value['guestId'] === undefined) return false;
    if (!('timeToLive' in value) || value['timeToLive'] === undefined) return false;
    return true;
}

export function APIAllInOneUserFromJSON(json: any): APIAllInOneUser {
    return APIAllInOneUserFromJSONTyped(json, false);
}

export function APIAllInOneUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAllInOneUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'self': json['self'],
        'isGuestUser': json['is_guest_user'],
        'isOrgAdmin': json['is_org_admin'],
        'isSuperuser': json['is_superuser'],
        'isStaff': json['is_staff'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'roles': json['roles'],
        'organization': json['organization'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'preferences': json['preferences'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'guestId': json['guest_id'],
        'timeToLive': json['time_to_live'],
        'repFor': json['rep_for'] == null ? undefined : json['rep_for'],
    };
}

export function APIAllInOneUserToJSON(value?: Omit<APIAllInOneUser, 'id'|'self'|'is_guest_user'|'is_org_admin'|'is_superuser'|'is_staff'|'roles'|'organization'|'preferences'|'first_name'|'last_name'|'guest_id'|'time_to_live'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_active': value['isActive'],
        'comment': value['comment'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'email': value['email'],
        'rep_for': value['repFor'],
    };
}

